import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { ErrorType } from "./custom-fetch";

export const reorderEstimateLineItems = async (
  estimateId: number,
  ids: number[]
): Promise<void> => {
  return customFetch<void>(
    `/api/estimates/${estimateId}/line-items/reorder`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ids }),
    }
  );
};

export const useReorderEstimateLineItems = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: UseMutationOptions<
    void,
    TError,
    { estimateId: number; ids: number[] },
    TContext
  >
) => {
  return useMutation<
    void,
    TError,
    { estimateId: number; ids: number[] },
    TContext
  >({
    mutationFn: ({ estimateId, ids }) =>
      reorderEstimateLineItems(estimateId, ids),
    ...options,
  });
};

export const reorderInvoiceLineItems = async (
  invoiceId: number,
  ids: number[]
): Promise<void> => {
  return customFetch<void>(
    `/api/invoices/${invoiceId}/line-items/reorder`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ids }),
    }
  );
};

export const useReorderInvoiceLineItems = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: UseMutationOptions<
    void,
    TError,
    { invoiceId: number; ids: number[] },
    TContext
  >
) => {
  return useMutation<
    void,
    TError,
    { invoiceId: number; ids: number[] },
    TContext
  >({
    mutationFn: ({ invoiceId, ids }) =>
      reorderInvoiceLineItems(invoiceId, ids),
    ...options,
  });
};
